var _effectorFileName = "/builds/gmini/front-utils/src/watchOnce.ts";
import { curry } from 'ramda';
export var watchOnce = curry(function (watcher, event) {
  var unsubscribe = event.watch(function (payload) {
    unsubscribe();
    watcher(payload);
  });
  return unsubscribe;
});